/**
 * Recommendation modülü için sabit değerler
 * Tüm magic number'lar bu dosyada merkezileştirilmiştir
 */

/**
 * Benzerlik eşik değerleri (similarity thresholds)
 */
const SIMILARITY_THRESHOLD = {
  /** Tam eşleşme - müşteri, ürün, dorse kontrolü için */
  EXACT_MATCH: 0.85,

  /** Yakın eşleşme - ürün tipi, son ürün kontrolü için */
  CLOSE_MATCH: 0.80,

  /** Gevşek eşleşme - alternatif eşleştirmeler için */
  LOOSE_MATCH: 0.75
};

/**
 * Mesafe limitleri (km cinsinden)
 */
const DISTANCE_LIMITS = {
  /** Yeniden atama için maksimum mesafe */
  MAX_REALLOCATION_DISTANCE: 300,

  /** Varsayılan alan hassasiyeti (20 ton ve altı siparişler için) */
  DEFAULT_AREA_SENSITIVITY: 200,

  /** Büyük siparişler için mesafe çarpanı (20 ton üstü) */
  LARGE_ORDER_MULTIPLIER: 2.5,

  /** Yakın şube mesafe limiti */
  CLOSE_BRANCH_DISTANCE: 250,

  /** Sequential sipariş için maksimum mesafe */
  SEQUENTIAL_MAX_DISTANCE: 100
};

/**
 * Araç kapasite aralıkları (kg cinsinden)
 */
const VEHICLE_CAPACITY = {
  /** Kırkayak araç minimum kapasitesi */
  CENTIPEDE_MIN: 18000,

  /** Kırkayak araç maksimum kapasitesi */
  CENTIPEDE_MAX: 22000,

  /** Özel tonaj aralığı minimum (26-30 ton -> 30.5 ton) */
  SPECIAL_RANGE_MIN: 26000,

  /** Özel tonaj aralığı maksimum */
  SPECIAL_RANGE_MAX: 30000,

  /** Özel aralık için ayarlanmış kapasite (ton) */
  SPECIAL_RANGE_ADJUSTED: 30.5,

  /** Küçük sipariş limiti (ton) - kırkayak kontrolü için */
  SMALL_ORDER_LIMIT: 20
};

/**
 * Ekipman skoru ağırlıkları
 */
const EQUIPMENT_SCORE_WEIGHTS = {
  /** Eksik zorunlu ekipman cezası */
  MISSING_REQUIRED: 0.3,

  /** Yetersiz zorunlu ekipman cezası */
  INSUFFICIENT_REQUIRED: 0.15,

  /** Eksik opsiyonel ekipman cezası (maksimum) */
  MISSING_OPTIONAL_MAX: 0.1,

  /** Yetersiz opsiyonel ekipman cezası (maksimum) */
  INSUFFICIENT_OPTIONAL_MAX: 0.05
};

/**
 * Öncelik hesaplama ağırlıkları
 */
const PRIORITY_WEIGHTS = {
  /** Öncelik değeri ağırlığı (0.3 = %30) */
  PRIORITY: 0.3,

  /** Maliyet değeri ağırlığı (0.7 = %70) */
  COST: 0.7,

  /** Yıkama gerektiğinde öncelik düşürme faktörü */
  WASH_PENALTY: 0.9,

  /** Aynı ürün taşındığında öncelik artırma faktörü */
  SAME_PRODUCT_BONUS: 0.9
};

/**
 * Batch işleme boyutları
 */
const BATCH_SIZES = {
  /** Maliyet hesaplama batch boyutu */
  COST_CALCULATION: 10,

  /** Yeniden atama için maksimum araç sayısı */
  REALLOCATION_LIMIT: 10
};

/**
 * Zaman hesaplama sabitleri
 */
const TIME_CONSTANTS = {
  /** Ortalama araç hızı (km/saat) */
  AVERAGE_SPEED: 60,

  /** Yükleme süresi (dakika) */
  LOADING_TIME: 30,

  /** Boşaltma süresi (dakika) */
  UNLOADING_TIME: 30,

  /** Tahmini sipariş süresi (saat) */
  ESTIMATED_ORDER_DURATION: 3
};

/**
 * Yıkama durumu kodları
 */
const WASHING_STATUS = {
  /** Yıkama gerekli */
  YES: 1,

  /** Yıkama gerekmez */
  NO: 2,

  /** Sürücü onayı gerekli */
  DRIVER_ACTION: 3
};

/**
 * ADR tip ID'si
 */
const ADR_TYPE_ID = 2;

/**
 * Araç have type değerleri
 */
const HAVE_TYPE = {
  /** Kiralık araç */
  RENTAL: 1,

  /** Özmal araç */
  OWNED: 2,

  /** Fark etmez */
  ANY: 3
};

module.exports = {
  SIMILARITY_THRESHOLD,
  DISTANCE_LIMITS,
  VEHICLE_CAPACITY,
  EQUIPMENT_SCORE_WEIGHTS,
  PRIORITY_WEIGHTS,
  BATCH_SIZES,
  TIME_CONSTANTS,
  WASHING_STATUS,
  ADR_TYPE_ID,
  HAVE_TYPE
};
